
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index9BGiJRc9HFAfsmh_re1Ygj9hfr13ecNBG91P_9vWWysMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/index.vue?macro=true";
import { default as loginSssu_cD6PwmgbDAPXqgXxX5wqIabR_45g2R_8J2K_45clDMMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/login.vue?macro=true";
import { default as verify0m8PQbfX3rvtIqBbnJbgnVWAGbY6MX3yF5MetC441hIMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/verify.vue?macro=true";
import { default as sitemap1q008mTflK_qOYSDLT5wWs3GBMTEkJFgfM9Hk2Hrf38Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/sitemap.vue?macro=true";
import { default as about_45usZgKzOMN8i6Si5sg8gN4Ueab0oPNdxa7h8Ft03KXn6OQMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/about-us.vue?macro=true";
import { default as registerClyYLPfONjsMx1M6Zg5OKL9gJZJMCoopsgKMZouVEzYMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/register.vue?macro=true";
import { default as complaintsH_452D0RkCRmjqAClvg6WdcWr2W_456SxsvcRdjRLtkUqakMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/complaints.vue?macro=true";
import { default as contact_45usGZGaIcSWuIJx3_45SGYpCT_45T61oADm5Ohlm6edk66b6yIMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/contact-us.vue?macro=true";
import { default as index_45sUf2UNtvjqYh0Fvu0mA_45OiuTPYFjH_45w8_aiRi__45WtsMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/media/index.vue?macro=true";
import { default as indexWcrFoLb071G6cGqkCCgr95iYDCkvH1rb94maHWsqzQcMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/energy/index.vue?macro=true";
import { default as _91slug_93hmE0RDUf_45ESmq_45ruA9gqutlV_1LHBwDAb8JccycIwhIMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/media/[slug].vue?macro=true";
import { default as partnershipsWGygz1W1JfBquYV_8YehQr_45_45pQB7Jms1rJeziz9HkmwMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/partnerships.vue?macro=true";
import { default as terms_45of_45usePTlodojt80ArnL12HRJ6RLDUoFTT3EPUnp2_KSWtZEUMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/terms-of-use.vue?macro=true";
import { default as indexasKKZbxDCLr7LQTfOrEZPNpps9MbeUwtXj21ms0BJ8oMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/careers/index.vue?macro=true";
import { default as privacy_45policyjzBj_454KGFXq0OhPzbuEYyI6QyFZryBYW8DTOLKHozsIMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/privacy-policy.vue?macro=true";
import { default as reset_45passwordoc1EB7XMOwzs9PqNhPUOSrAI4QowK9IEUvwxikLNvJgMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/reset-password.vue?macro=true";
import { default as indexmoIOQDm6MH0ZmEfo0nNo5acHrdD5cxXUCSTnCZiCqN8Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/car-loans/index.vue?macro=true";
import { default as index4kGm3sJuiAGSun7TdBmKhS_Pt6Jb0CxpVcZ8vjnfBwYMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/index.vue?macro=true";
import { default as legal6fGInRetCKlFzLqDEv8AnQYTCCKhXy_459k4s6i0fAVjwMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/legal.vue?macro=true";
import { default as forgot_45passwordK0wC71zbQ47peI5LmjjOg7hRy4jDFwD46bBMeZDuUzYMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/forgot-password.vue?macro=true";
import { default as errorCI72jWjmKyZ_FmBrUp5nJFrI1UByfjs90rBZ8bcsJHcMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/energy/cdr/error.vue?macro=true";
import { default as index1IdkXbCEmy_9f21siJ4mCFbgNW_oQVwmmTg2IsvGth8Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/home-loans/index.vue?macro=true";
import { default as _91slug_93pqVAcBEI9clFCcznMI5RDN2QThYwLk34lr6urGN_W78Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/[vertical]/[slug].vue?macro=true";
import { default as guides5dbnv9GBIMh9GAuoxYy_CtNqhI9Wa4rZr1syhrVWx0sMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/[vertical]/guides.vue?macro=true";
import { default as collection_45notice8_jS4WkDntpAqOABqznvOvaoNGwj6xmiKoX7AIyQuk4Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/collection-notice.vue?macro=true";
import { default as indexAXekeJRlZhJxqWjpzQ8WRKVAjTYVDBVWDJr4E8TGRSgMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/credit-cards/index.vue?macro=true";
import { default as set_45password8yr_45uLnJcYXJCmgYSNXp44_toLDQMuUS4XMDMnn9U04Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/guest/set-password.vue?macro=true";
import { default as welcome_45backlMwC_eMku2TBhtXECIi9GvwnVmKB9w_45ohAAeuB1FLQEMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/guest/welcome-back.vue?macro=true";
import { default as merge23w72bo9nAB_3As9FA4o8qpdLhVtIfdX_45IPUbbDEIRAMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/authorization/merge.vue?macro=true";
import { default as index_45RMUkmulsq35Ctk_45E3LHKhpFD_Zb1j0l8cvtmeMnutAMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/car-insurance/index.vue?macro=true";
import { default as _91slug_93cFYqtlEu7QpBnhLxRerZtjHNgtlC1gnZPb9U5epV3woMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/credit-cards/[slug].vue?macro=true";
import { default as post_45sale_45thank_45youLKeYsrEsKN6SVHCb_TetIC5H8oTVcswSBHv8dlVz9DgMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/post-sale-thank-you.vue?macro=true";
import { default as thank_45youEzPaMbhlR78g03tn5qB8mcDkWdXnbnkDm1uWAco_45e2cMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/energy/cdr/thank-you.vue?macro=true";
import { default as indexMtnHTZS_45vuwND42bCDlZa2vTj5u3Gyv9F_XJBDPUxPkMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/index.vue?macro=true";
import { default as indexe3lU_45jFlvo7fSV4vgjVnajvPRUt4HCCXDAlXlhkuCPQMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/personal-loans/index.vue?macro=true";
import { default as _91slug_93r2n8tfLKdygzAL_v8yVxYabGe_45bTDugO1D9ITEwPBLkMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/preview/media/[slug].vue?macro=true";
import { default as indexcdpSL43_bxOusUWAMCczKRIIcBWjxybZeQF3p5D45ygMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/perks/index.vue?macro=true";
import { default as indexUAIt0t2aMP2_7QjTqNDQ0OKq4NEj7EVCvveewmg6z_8Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/expert-analysis/index.vue?macro=true";
import { default as _91author_930eif2Rt3ztyC5pYG_456yZKbBLdaxbMxJmg7GU_UlYeqIMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/media/author/[author].vue?macro=true";
import { default as callback2I1FkFeK6nNrLkcqK52Sl4ORNG6sIKBsHl61EBV0rg8Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/authorization/callback.vue?macro=true";
import { default as buyer_45protection_45claimwaOvpJqqy49YJLhKpQBQyOcUMHQvd_zBYpO5U72NgnYMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/buyer-protection-claim.vue?macro=true";
import { default as indexK1XxVU_45U09T4C_wuUEjhKS8QQyhleAfF9GeWGviT2ywMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/quotes/index.vue?macro=true";
import { default as thank_45youV2I_45E3QU5Gq_45ZRRT7oZjY3z60XakdxJkByESnav6SukMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/energy/quote/thank-you.vue?macro=true";
import { default as errorlSnoQE_45ICS83zumfW60Men3Q4y33kuPEeaI6QnntgCQMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/error.vue?macro=true";
import { default as indexFYaeZMFDtDr9UEk5KVo6o86n4BMcyECEQlxoLZhogDgMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/index.vue?macro=true";
import { default as indexMoLWNz5HVKMJ_9Z1xoXODp5_453rOdv7rRUhU_0k4AIaMMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/rewards/index.vue?macro=true";
import { default as errordGIaFBz6ufpGvZtFvciQHm_bOE2WBHpHz2W0UzG2ZIwMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/energy/application/error.vue?macro=true";
import { default as _91step_93rWIyGQpabSapi7pY1BUWxFZX3WxT2nCugIrwcB6gwTAMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/energy/quote/form/[step].vue?macro=true";
import { default as detailsyOgkf64h5L0xSi0vF00EVWmEW9RpHOrd1_gabanPvI4Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/energy/quote/form/details.vue?macro=true";
import { default as interest_45rates6fodBf7EmMvBwt7grL8c_s__45fKSig8c7NcDMgw2RmdIMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/home-loans/interest-rates.vue?macro=true";
import { default as _91slug_93mDqVl0yzTbTCsU4liL4whnuwBaKDx2rtU0p3l4f4kdEMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/preview/[vertical]/[slug].vue?macro=true";
import { default as indexcH7q9bnVsBjpgJkaEIIh7GhFY84wh3YIhnKUwd8u3k0Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/[vertical]/companies/index.vue?macro=true";
import { default as account_45settingsCHI3jlroLLpQgooTYwuf4KJf5Y42m6iwEb20qMABgTsMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/account-settings.vue?macro=true";
import { default as index7sI0ONlyTiyBN6812XbTVBQL0LpBFt6km19hSIza75oMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/onboarding/index.vue?macro=true";
import { default as live_45chattML1_jJejxBWo_45oKGMvkspThtso5Tym2xPsUzimXNskMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/live-chat.vue?macro=true";
import { default as post_45saleIsYtPtPkutrrHwuJkM0_eEASVJQ37Fu33BwQ5lMN_45pIMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/post-sale.vue?macro=true";
import { default as thank_45youMFkAnJ9ayHUYgmI7w6IVLypmAzqOIafCBIG_45rr_Fv_454Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/home-loans/quote/thank-you.vue?macro=true";
import { default as comprehensive606Ih9kmOmwxJPaiqFFz8uVCnxp5f9A8wGMf8cJUYn8Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/car-insurance/comprehensive.vue?macro=true";
import { default as _91slug_93rQlClcSFEz0cwkCDN_45xNFXjkN24yIOFQeJEyZn9s1FMMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/credit-cards/preview/[slug].vue?macro=true";
import { default as addeiNGJJ9OuEwpx0HNFBxOAFrJn5WThd2eoUXxwd0byjQMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/partners/add.vue?macro=true";
import { default as index9PgmmP9mBcrCt0fvdYqCDQwOy8lnO18rBMr21pr9vZgMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/[vertical]/schedule-callback/index.vue?macro=true";
import { default as _91response_93TfoOKrndm_456HLQMDWSF_7iQi_45WrDr5QS3q_45D4eTsQUwMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/[vertical]/schedule-callback/[response].vue?macro=true";
import { default as schedule_45callbackTNnasOgyfNPQSWV1ZgWJDQ9bkcz2TdtORyWFQ4nUGhoMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/[vertical]/schedule-callback.vue?macro=true";
import { default as _91slug_938wxKEVRrrHXi_45Ulp3VpvurhjxXMgrJj5zgsA9FBNPfoMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/credit-cards/redirect/[slug].vue?macro=true";
import { default as thank_45youI_458qfVPyGDxDoFe3H2iewUn_UDmg_45aw_45T7mVtl183F0Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/energy/application/thank-you.vue?macro=true";
import { default as live_45chat_45b8SQwZiyusfp8AVbmr0KHLW3yFLhDzVF3oUzQZ_456vxMIMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/live-chat-b.vue?macro=true";
import { default as indexaue5CGKtl_paGn6H3JfCWGHdMXNZ4F15B2nuaifRf_454Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/home-loans/calculators/index.vue?macro=true";
import { default as _91step_93_zePVo4z8VkR7aiYcSyjiIVBNdIBdNhiSGXMc31mMBAMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/home-loans/quote/form/[step].vue?macro=true";
import { default as _91slug_93iuujtIgkxCx0zNmashifRrJ6Jvwax81I1nICdTBTvcYMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/car-insurance/redirect/[slug].vue?macro=true";
import { default as indexfEodC1Okj2tTwmcPO9dWwYm31VWbZ2jR31_45TwtN1P3QMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/offers/index.vue?macro=true";
import { default as addI_B0rtCrSRD3A93Dn0him_Hf0koL2ntyFVkjAguMq3YMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/partners/add.vue?macro=true";
import { default as _91type_9326eTmv8FbPurs5lBBAOvh1pf0mlZiuuY8wUdb5UlcHsMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/home-loans/calculators/[type].vue?macro=true";
import { default as detailspdY3vdjoEKHa_45vMuy_45zhWA7NcAJblbTkyyWDZgrKFCkMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/home-loans/quote/form/details.vue?macro=true";
import { default as callbackco1vV7kdO85_45h0ggGN6oASRARHQoxbkVgJ9svpXqzEcMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/quote/callback.vue?macro=true";
import { default as digital_45eicBPgBteMikjHZOIXUbBwFLK_456z62YLaOsCpXNTRar0DMMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/energy/application/digital-eic.vue?macro=true";
import { default as thank_45youBopZegqiZZh0fdoouUHdpiZbPpLt4gFfiH_hBNMFBb8Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/personal-loans/quote/thank-you.vue?macro=true";
import { default as _91step_93CIdi8pCg9QXYPw4nzVz7I7KqksxfgABC4o1NQi_45QNt0Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/car-insurance/quote/form/[step].vue?macro=true";
import { default as _91author_93IOzYqRlxn07SymVZj7WlCJ_6H7Vu6eCNjmuAE_45THHQkMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/expert-analysis/author/[author].vue?macro=true";
import { default as comparisonYxYuwfwIhjOVsx_xLj3xVBNJZV4_45rNMmbieljS1bRe4Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/quote/comparison.vue?macro=true";
import { default as step1ourdHehkOR3UvjlbKCKKWYcyW5ipIi_8GPFk9NCR7w8Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/quote/form/step1.vue?macro=true";
import { default as detailsLWhtVznSPz07C0MafyySBGQJtnye4rDkdI9Ay33an0MMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/car-insurance/quote/form/details.vue?macro=true";
import { default as resultsozZUWh14EZ48XRRCQoJQvUXrEW93fZndEJDZ9HzQAv4Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/car-insurance/quote/form/results.vue?macro=true";
import { default as index_9NZkp_OCOI7fB6toKi3E4ln9fF4xEVjLHNlAkQ3xwAMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/expert-analysis/[category]/index.vue?macro=true";
import { default as signupDdPGtDq_45zkcTpe0gp79wOboXiHCp9Qs_45fYLStU6P5nkMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/partners/signup.vue?macro=true";
import { default as thank_45youaJWnACDzcQg4uBBnmucYl9v4woc9HfARVz_45clhDYs60Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/quote/thank-you.vue?macro=true";
import { default as _91step_93GwsMxITcSHa7fIRkfyef4_45rlKaZrjzvnNHko_BMPdP8Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/personal-loans/quote/form/[step].vue?macro=true";
import { default as _91slug_93AhD7_45Ag_SKdo_btOXC_cDNdt3utBzrOmr8WCAh2rGZcMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/expert-analysis/[category]/[slug].vue?macro=true";
import { default as step0M0XZLQZ79qxnPcNJfURMfpLpKx9Z_451gSIXHi8ar53o0Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/quote/form/step0.vue?macro=true";
import { default as existing_45customersytpdEDhm7kpSbf8AVrVA0rLoOz6LVxzmEQAhTdAC68MMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/existing-customers.vue?macro=true";
import { default as thank_45youGnp009mUyCmP7pqt3aGhVD5I24bU7Omx2mJPaeWV_4510Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/partners/thank-you.vue?macro=true";
import { default as detailsUhRAplaUgrPnzIkogdyJ8D2DVNP70UcRsnpoEU827PQMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/quote/form/details.vue?macro=true";
import { default as detailstPQvqNcJKQj6XZUfu1kXoRbYzQMk9oGMdNIlQXNvrYQMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/personal-loans/quote/form/details.vue?macro=true";
import { default as _91step_93VfVQdaQJ7QodVfPgRRblEGTWRDJ9p_459_u30M5Rsd1scMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/quote/form/[step].vue?macro=true";
import { default as rebate66bEbnN21IYRv4Z1Mwqa0_45_KV2tYurmKr0gguWBZAKwMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/vault/[...product]/rebate.vue?macro=true";
import { default as _91step_93F8mWNlrZ3uwKzs0BaIZNy4FZYSDCnT7UCamIc6ccLVcMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/application/[step].vue?macro=true";
import { default as detailsq5C2mV4HXzGMo26T5GifdoqPXsgZ_4U92f6Am28QZ_0Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/quote/form/details.vue?macro=true";
import { default as step0SdCCRosLoJKJ3s3JzNQVz0nK1mdaP7oNydwsI0E89q0Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/quote/policy/step0.vue?macro=true";
import { default as index5VfQS7GU4dcKht3hf2xWoXJAR48X4g2uCfOY3_45FjvqcMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/quote/resume/index.vue?macro=true";
import { default as indexqcCqxDhLDlCA6iirdtz5Vz4rIpaNW_VI0dnEnB9Ne_IMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/quote/customer/index.vue?macro=true";
import { default as detailsBTuvuatNk9bV2UigRLgZQ4WfPc1Z2CdUGJCd2QXq1n0Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/vault/[...product]/details.vue?macro=true";
import { default as terms_45and_45conditionsSPWXxD6yq5C61nCnyWcl6Bxhm48exCZzqrRzNfXOSfkMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/buyer-protection/terms-and-conditions.vue?macro=true";
import { default as _91location_93_8FH__vmBBGHKQwA60bmaFVe13TmiLPseRkUkx7ZUo0Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/energy/compare-by-location/[location].vue?macro=true";
import { default as indexpJJbwxKBgHEcx543VNFQ8LyorTp_45YP6jyVEOQhLoF3wMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/quote/customer/index.vue?macro=true";
import { default as detailsAaFHgzfSs8cYsOZTzpiU1KW4dw5qcp_s2MuUdr76VW4Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/quote/policy/details.vue?macro=true";
import { default as indexDoFD6T76hWdcgHB_45ddVcKGtGWlusxdJbPLwwSTkYE_gMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/quotes-results/index.vue?macro=true";
import { default as success6047P51hZkNTIf0utN_45w5WZ30dpqZku3NkrmY0bDdKgMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/quote/customer/success.vue?macro=true";
import { default as claim_45offerCKPjU4R9HRhVoAAufvbyLlQy90dMjcKR9GPijM08rpgMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/offers/[vertical]/claim-offer.vue?macro=true";
import { default as lic_45detailsR_4MHG_SpRH_4oayF4huT46C0DPWFz8liGvOYibdgr8Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/vault/[...product]/lic-details.vue?macro=true";
import { default as _91step_93gYREhs2_450bdCAsmxnEZoCvbg8bjx8mRB71Z_BZ1yUwoMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/quote/policy/step/[step].vue?macro=true";
import { default as indexWes5Xi5Byk9OuBpTdogVUpJcwns_e1nZ6MOEDQU2xtEMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/index.vue?macro=true";
import { default as _91slug_93PegDIL7nmrGa910zuXBGOCXq9HvQMUtY9wpql1wtTugMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/preview/expert-analysis/[vertical]/[slug].vue?macro=true";
import { default as indexN7lhpGV_45f1Q4TS3yVjKUfT0S8UGVDvTfYOj05nxMid0Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/application/payment/index.vue?macro=true";
import { default as _91step_93m5l6_45FWQHfno9Yx_52NGo2kDAGGUpY6NRWIlGWD8mMoMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/[step].vue?macro=true";
import { default as indexeUxIuBgv_45r5FVA8Zmpn4jdyKrF0TIKVUYe_45sWgyuWCsMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/application/thankyou/index.vue?macro=true";
import { default as indexyiPRuswEC4TJZCiclsQ2MjHAFHY41IRanOaCod6k_45DEMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/rate-rise-calculator/index.vue?macro=true";
import { default as detailsCzRKA8UsfNPMsKYWpJDHJdUMU8AQyzUiPOpNuvMO2RYMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/details.vue?macro=true";
import { default as expiredVSJemQHcm9YfT7hKSysa9tpGCOuXSHAVFKQpQ83duGsMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/application/payment/expired.vue?macro=true";
import { default as indexU4LsGMoowCDiqit064_45jCuYr0bSGjNKG8SBzMVRaxLEMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/income-protection/quote/index.vue?macro=true";
import { default as thank_45youGLHNfNa2EhOWaRy6EbVnwaqTHsyZyVI_45_bI5VHPYGjkMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/thank-you.vue?macro=true";
import { default as details4P7YCOEGjk_45oF0R7vfL9YSQL4unsVaVP_kN58_45aF9NEMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/income-protection/quote/details.vue?macro=true";
import { default as confirmationZ9rBDf_LAs7cTdQcsCPvVD0WiUNSh_z31yoiMwZ3hmAMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/confirmation.vue?macro=true";
import { default as completionfKdYh75JPvlu1Fj7VL6_451_45nJALeVMv276P1GdMXQQhwMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/vault/[...product]/[vertical]/completion.vue?macro=true";
import { default as quotes_45resultsnGMQiblgYNo2UQ_45mAvzTnbzd_elZ9kOXC64Ff1xOvngMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/quotes-results.vue?macro=true";
import { default as confirmation2rkRZ_45Xe0qFeDS3ZZPSIfyxz3xQjmSkh6fpFlXzzyB8Meta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/income-protection/quote/confirmation.vue?macro=true";
import { default as _91step_93ikdOlZTaCLAIz_EJwsHlIHjfLs91otjvD6d1w7jwPoYMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/vault/[...product]/form/energy/step/[step].vue?macro=true";
import { default as _91step_93U1EhOp3MxCKUcevlcC_45bk8nPrkjm7iGN_45u6IbFzj_45PUMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/vault/[...product]/form/generic/step/[step].vue?macro=true";
import { default as _91step_93xb8_xis1osuQrZEaSFOROf_G0WImOBNzSTp_45K9ccbAYMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/application/[step].vue?macro=true";
import { default as _91step_93JM_7vnlh0VS1kLHjfpfxWgf5IykXuzJIRK5q100nYqEMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/vault/[...product]/form/home-loan/step/[step].vue?macro=true";
import { default as indexmNGQSjITVsWWyubdORyFpADbIkOZrB2H30T68ZsDqXMMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/students-offer/[university]/form/index.vue?macro=true";
import { default as additional_45detailsAYJMPuMSw2qqlWkW1l4dW5VwrHvaQHM7sqFRJczd_45gsMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/vault/[...product]/[vertical]/additional-details.vue?macro=true";
import { default as _91step_93cvgED8W_kvK40fBra6zZo15eeXAciJdFtq_45EODA3eccMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/vault/[...product]/form/life-insurance/step/[step].vue?macro=true";
import { default as _91step_93tbGQhZQebZFwq7caXzgbVbYGHC_45jzr4oghnm1HSWi3sMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/vault/[...product]/form/health-insurance/step/[step].vue?macro=true";
import { default as indexWg7LRyb02hpAwcPAHZrN0iklijinRCweNRDOuvoySmgMeta } from "/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/students-offer/[university]/terms-conditions/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginSssu_cD6PwmgbDAPXqgXxX5wqIabR_45g2R_8J2K_45clDMMeta || {},
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/login.vue")
  },
  {
    name: "verify",
    path: "/verify",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/verify.vue")
  },
  {
    name: "sitemap",
    path: "/sitemap",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/sitemap.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/about-us.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerClyYLPfONjsMx1M6Zg5OKL9gJZJMCoopsgKMZouVEzYMeta || {},
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/register.vue")
  },
  {
    name: "complaints",
    path: "/complaints",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/complaints.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/contact-us.vue")
  },
  {
    name: "media",
    path: "/media",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/media/index.vue")
  },
  {
    name: "energy",
    path: "/energy",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/energy/index.vue")
  },
  {
    name: "media-slug",
    path: "/media/:slug()",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/media/[slug].vue")
  },
  {
    name: "partnerships",
    path: "/partnerships",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/partnerships.vue")
  },
  {
    name: "terms-of-use",
    path: "/terms-of-use",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/terms-of-use.vue")
  },
  {
    name: "careers",
    path: "/careers",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/careers/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/privacy-policy.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordoc1EB7XMOwzs9PqNhPUOSrAI4QowK9IEUvwxikLNvJgMeta || {},
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/reset-password.vue")
  },
  {
    name: "car-loans",
    path: "/car-loans",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/car-loans/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: index4kGm3sJuiAGSun7TdBmKhS_Pt6Jb0CxpVcZ8vjnfBwYMeta || {},
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/index.vue")
  },
  {
    name: "dashboard-legal",
    path: "/dashboard/legal",
    meta: legal6fGInRetCKlFzLqDEv8AnQYTCCKhXy_459k4s6i0fAVjwMeta || {},
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/legal.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordK0wC71zbQ47peI5LmjjOg7hRy4jDFwD46bBMeZDuUzYMeta || {},
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/forgot-password.vue")
  },
  {
    name: "energy-cdr-error",
    path: "/energy/cdr/error",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/energy/cdr/error.vue")
  },
  {
    name: "home-loans",
    path: "/home-loans",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/home-loans/index.vue")
  },
  {
    name: "vertical-slug",
    path: "/:vertical()/:slug()",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/[vertical]/[slug].vue")
  },
  {
    name: "vertical-guides",
    path: "/:vertical()/guides",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/[vertical]/guides.vue")
  },
  {
    name: "collection-notice",
    path: "/collection-notice",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/collection-notice.vue")
  },
  {
    name: "credit-cards",
    path: "/credit-cards",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/credit-cards/index.vue")
  },
  {
    name: "guest-set-password",
    path: "/guest/set-password",
    meta: set_45password8yr_45uLnJcYXJCmgYSNXp44_toLDQMuUS4XMDMnn9U04Meta || {},
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/guest/set-password.vue")
  },
  {
    name: "guest-welcome-back",
    path: "/guest/welcome-back",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/guest/welcome-back.vue")
  },
  {
    name: "authorization-merge",
    path: "/authorization/merge",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/authorization/merge.vue")
  },
  {
    name: "car-insurance",
    path: "/car-insurance",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/car-insurance/index.vue")
  },
  {
    name: "credit-cards-slug",
    path: "/credit-cards/:slug()",
    meta: _91slug_93cFYqtlEu7QpBnhLxRerZtjHNgtlC1gnZPb9U5epV3woMeta || {},
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/credit-cards/[slug].vue")
  },
  {
    name: "post-sale-thank-you",
    path: "/post-sale-thank-you",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/post-sale-thank-you.vue")
  },
  {
    name: "energy-cdr-thank-you",
    path: "/energy/cdr/thank-you",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/energy/cdr/thank-you.vue")
  },
  {
    name: "life-insurance",
    path: "/life-insurance",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/index.vue")
  },
  {
    name: "personal-loans",
    path: "/personal-loans",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/personal-loans/index.vue")
  },
  {
    name: "preview-media-slug",
    path: "/preview/media/:slug()",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/preview/media/[slug].vue")
  },
  {
    name: "dashboard-perks",
    path: "/dashboard/perks",
    meta: indexcdpSL43_bxOusUWAMCczKRIIcBWjxybZeQF3p5D45ygMeta || {},
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/perks/index.vue")
  },
  {
    name: "expert-analysis",
    path: "/expert-analysis",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/expert-analysis/index.vue")
  },
  {
    name: "media-author-author",
    path: "/media/author/:author()",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/media/author/[author].vue")
  },
  {
    name: "authorization-callback",
    path: "/authorization/callback",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/authorization/callback.vue")
  },
  {
    name: "buyer-protection-claim",
    path: "/buyer-protection-claim",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/buyer-protection-claim.vue")
  },
  {
    name: "dashboard-quotes",
    path: "/dashboard/quotes",
    meta: indexK1XxVU_45U09T4C_wuUEjhKS8QQyhleAfF9GeWGviT2ywMeta || {},
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/quotes/index.vue")
  },
  {
    name: "energy-quote-thank-you",
    path: "/energy/quote/thank-you",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/energy/quote/thank-you.vue")
  },
  {
    name: "health-insurance-error",
    path: "/health-insurance/error",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/error.vue")
  },
  {
    name: "health-insurance",
    path: "/health-insurance",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/index.vue")
  },
  {
    name: "dashboard-rewards",
    path: "/dashboard/rewards",
    props: indexMoLWNz5HVKMJ_9Z1xoXODp5_453rOdv7rRUhU_0k4AIaMMeta?.props ?? {"verificationNeeded":true},
    meta: indexMoLWNz5HVKMJ_9Z1xoXODp5_453rOdv7rRUhU_0k4AIaMMeta || {},
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/rewards/index.vue")
  },
  {
    name: "energy-application-error",
    path: "/energy/application/error",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/energy/application/error.vue")
  },
  {
    name: "energy-quote-form-step",
    path: "/energy/quote/form/:step()",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/energy/quote/form/[step].vue")
  },
  {
    name: "energy-quote-form-details",
    path: "/energy/quote/form/details",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/energy/quote/form/details.vue")
  },
  {
    name: "home-loans-interest-rates",
    path: "/home-loans/interest-rates",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/home-loans/interest-rates.vue")
  },
  {
    name: "preview-vertical-slug",
    path: "/preview/:vertical()/:slug()",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/preview/[vertical]/[slug].vue")
  },
  {
    name: "vertical-companies",
    path: "/:vertical()/companies",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/[vertical]/companies/index.vue")
  },
  {
    name: "dashboard-account-settings",
    path: "/dashboard/account-settings",
    meta: account_45settingsCHI3jlroLLpQgooTYwuf4KJf5Y42m6iwEb20qMABgTsMeta || {},
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/account-settings.vue")
  },
  {
    name: "dashboard-onboarding",
    path: "/dashboard/onboarding",
    meta: index7sI0ONlyTiyBN6812XbTVBQL0LpBFt6km19hSIza75oMeta || {},
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/onboarding/index.vue")
  },
  {
    name: "health-insurance-live-chat",
    path: "/health-insurance/live-chat",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/live-chat.vue")
  },
  {
    name: "health-insurance-post-sale",
    path: "/health-insurance/post-sale",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/post-sale.vue")
  },
  {
    name: "home-loans-quote-thank-you",
    path: "/home-loans/quote/thank-you",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/home-loans/quote/thank-you.vue")
  },
  {
    name: "car-insurance-comprehensive",
    path: "/car-insurance/comprehensive",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/car-insurance/comprehensive.vue")
  },
  {
    name: "credit-cards-preview-slug",
    path: "/credit-cards/preview/:slug()",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/credit-cards/preview/[slug].vue")
  },
  {
    name: "life-insurance-partners-add",
    path: "/life-insurance/partners/add",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/partners/add.vue")
  },
  {
    name: schedule_45callbackTNnasOgyfNPQSWV1ZgWJDQ9bkcz2TdtORyWFQ4nUGhoMeta?.name,
    path: "/:vertical()/schedule-callback",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/[vertical]/schedule-callback.vue"),
    children: [
  {
    name: "vertical-schedule-callback",
    path: "",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/[vertical]/schedule-callback/index.vue")
  },
  {
    name: "vertical-schedule-callback-response",
    path: ":response()",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/[vertical]/schedule-callback/[response].vue")
  }
]
  },
  {
    name: "credit-cards-redirect-slug",
    path: "/credit-cards/redirect/:slug()",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/credit-cards/redirect/[slug].vue")
  },
  {
    name: "energy-application-thank-you",
    path: "/energy/application/thank-you",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/energy/application/thank-you.vue")
  },
  {
    name: "health-insurance-live-chat-b",
    path: "/health-insurance/live-chat-b",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/live-chat-b.vue")
  },
  {
    name: "home-loans-calculators",
    path: "/home-loans/calculators",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/home-loans/calculators/index.vue")
  },
  {
    name: "home-loans-quote-form-step",
    path: "/home-loans/quote/form/:step()",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/home-loans/quote/form/[step].vue")
  },
  {
    name: "car-insurance-redirect-slug",
    path: "/car-insurance/redirect/:slug()",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/car-insurance/redirect/[slug].vue")
  },
  {
    name: "health-insurance-offers",
    path: "/health-insurance/offers",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/offers/index.vue")
  },
  {
    name: "health-insurance-partners-add",
    path: "/health-insurance/partners/add",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/partners/add.vue")
  },
  {
    name: "home-loans-calculators-type",
    path: "/home-loans/calculators/:type()",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/home-loans/calculators/[type].vue")
  },
  {
    name: "home-loans-quote-form-details",
    path: "/home-loans/quote/form/details",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/home-loans/quote/form/details.vue")
  },
  {
    name: "life-insurance-quote-callback",
    path: "/life-insurance/quote/callback",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/quote/callback.vue")
  },
  {
    name: "energy-application-digital-eic",
    path: "/energy/application/digital-eic",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/energy/application/digital-eic.vue")
  },
  {
    name: "personal-loans-quote-thank-you",
    path: "/personal-loans/quote/thank-you",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/personal-loans/quote/thank-you.vue")
  },
  {
    name: "car-insurance-quote-form-step",
    path: "/car-insurance/quote/form/:step()",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/car-insurance/quote/form/[step].vue")
  },
  {
    name: "expert-analysis-author-author",
    path: "/expert-analysis/author/:author()",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/expert-analysis/author/[author].vue")
  },
  {
    name: "life-insurance-quote-comparison",
    path: "/life-insurance/quote/comparison",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/quote/comparison.vue")
  },
  {
    name: "life-insurance-quote-form-step1",
    path: "/life-insurance/quote/form/step1",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/quote/form/step1.vue")
  },
  {
    name: "car-insurance-quote-form-details",
    path: "/car-insurance/quote/form/details",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/car-insurance/quote/form/details.vue")
  },
  {
    name: "car-insurance-quote-form-results",
    path: "/car-insurance/quote/form/results",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/car-insurance/quote/form/results.vue")
  },
  {
    name: "expert-analysis-category",
    path: "/expert-analysis/:category()",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/expert-analysis/[category]/index.vue")
  },
  {
    name: "health-insurance-partners-signup",
    path: "/health-insurance/partners/signup",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/partners/signup.vue")
  },
  {
    name: "health-insurance-quote-thank-you",
    path: "/health-insurance/quote/thank-you",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/quote/thank-you.vue")
  },
  {
    name: "personal-loans-quote-form-step",
    path: "/personal-loans/quote/form/:step()",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/personal-loans/quote/form/[step].vue")
  },
  {
    name: "expert-analysis-category-slug",
    path: "/expert-analysis/:category()/:slug()",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/expert-analysis/[category]/[slug].vue")
  },
  {
    name: "health-insurance-quote-form-step0",
    path: "/health-insurance/quote/form/step0",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/quote/form/step0.vue")
  },
  {
    name: "life-insurance-existing-customers",
    path: "/life-insurance/existing-customers",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/existing-customers.vue")
  },
  {
    name: "life-insurance-partners-thank-you",
    path: "/life-insurance/partners/thank-you",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/partners/thank-you.vue")
  },
  {
    name: "life-insurance-quote-form-details",
    path: "/life-insurance/quote/form/details",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/quote/form/details.vue")
  },
  {
    name: "personal-loans-quote-form-details",
    path: "/personal-loans/quote/form/details",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/personal-loans/quote/form/details.vue")
  },
  {
    name: "health-insurance-quote-form-step",
    path: "/health-insurance/quote/form/:step()",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/quote/form/[step].vue")
  },
  {
    name: "dashboard-vault-product-rebate",
    path: "/dashboard/vault/:product([^/]*)*/rebate",
    meta: rebate66bEbnN21IYRv4Z1Mwqa0_45_KV2tYurmKr0gguWBZAKwMeta || {},
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/vault/[...product]/rebate.vue")
  },
  {
    name: "health-insurance-application-step",
    path: "/health-insurance/application/:step()",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/application/[step].vue")
  },
  {
    name: "health-insurance-quote-form-details",
    path: "/health-insurance/quote/form/details",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/quote/form/details.vue")
  },
  {
    name: "health-insurance-quote-policy-step0",
    path: "/health-insurance/quote/policy/step0",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/quote/policy/step0.vue")
  },
  {
    name: "health-insurance-quote-resume",
    path: "/health-insurance/quote/resume",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/quote/resume/index.vue")
  },
  {
    name: "life-insurance-quote-customer",
    path: "/life-insurance/quote/customer",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/quote/customer/index.vue")
  },
  {
    name: "dashboard-vault-product-details",
    path: "/dashboard/vault/:product([^/]*)*/details",
    meta: detailsBTuvuatNk9bV2UigRLgZQ4WfPc1Z2CdUGJCd2QXq1n0Meta || {},
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/vault/[...product]/details.vue")
  },
  {
    name: "buyer-protection-terms-and-conditions",
    path: "/buyer-protection/terms-and-conditions",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/buyer-protection/terms-and-conditions.vue")
  },
  {
    name: "energy-compare-by-location-location",
    path: "/energy/compare-by-location/:location()",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/energy/compare-by-location/[location].vue")
  },
  {
    name: "health-insurance-quote-customer",
    path: "/health-insurance/quote/customer",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/quote/customer/index.vue")
  },
  {
    name: "health-insurance-quote-policy-details",
    path: "/health-insurance/quote/policy/details",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/quote/policy/details.vue")
  },
  {
    name: "health-insurance-quotes-results",
    path: "/health-insurance/quotes-results",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/quotes-results/index.vue")
  },
  {
    name: "life-insurance-quote-customer-success",
    path: "/life-insurance/quote/customer/success",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/quote/customer/success.vue")
  },
  {
    name: "dashboard-offers-vertical-claim-offer",
    path: "/dashboard/offers/:vertical()/claim-offer",
    meta: claim_45offerCKPjU4R9HRhVoAAufvbyLlQy90dMjcKR9GPijM08rpgMeta || {},
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/offers/[vertical]/claim-offer.vue")
  },
  {
    name: "dashboard-vault-product-lic-details",
    path: "/dashboard/vault/:product([^/]*)*/lic-details",
    meta: lic_45detailsR_4MHG_SpRH_4oayF4huT46C0DPWFz8liGvOYibdgr8Meta || {},
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/vault/[...product]/lic-details.vue")
  },
  {
    name: "health-insurance-quote-policy-step-step",
    path: "/health-insurance/quote/policy/step/:step()",
    meta: _91step_93gYREhs2_450bdCAsmxnEZoCvbg8bjx8mRB71Z_BZ1yUwoMeta || {},
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/quote/policy/step/[step].vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc",
    path: "/health-insurance/visitors-visa-ovhc",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/index.vue")
  },
  {
    name: "preview-expert-analysis-vertical-slug",
    path: "/preview/expert-analysis/:vertical()/:slug()",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/preview/expert-analysis/[vertical]/[slug].vue")
  },
  {
    name: "health-insurance-application-payment",
    path: "/health-insurance/application/payment",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/application/payment/index.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-step",
    path: "/health-insurance/visitors-visa-ovhc/:step()",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/[step].vue")
  },
  {
    name: "health-insurance-application-thankyou",
    path: "/health-insurance/application/thankyou",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/application/thankyou/index.vue")
  },
  {
    name: "health-insurance-rate-rise-calculator",
    path: "/health-insurance/rate-rise-calculator",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/rate-rise-calculator/index.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-details",
    path: "/health-insurance/visitors-visa-ovhc/details",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/details.vue")
  },
  {
    name: "health-insurance-application-payment-expired",
    path: "/health-insurance/application/payment/expired",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/application/payment/expired.vue")
  },
  {
    name: "life-insurance-income-protection-quote",
    path: "/life-insurance/income-protection/quote",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/income-protection/quote/index.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-thank-you",
    path: "/health-insurance/visitors-visa-ovhc/thank-you",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/thank-you.vue")
  },
  {
    name: "life-insurance-income-protection-quote-details",
    path: "/life-insurance/income-protection/quote/details",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/income-protection/quote/details.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-confirmation",
    path: "/health-insurance/visitors-visa-ovhc/confirmation",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/confirmation.vue")
  },
  {
    name: "dashboard-vault-product-vertical-completion",
    path: "/dashboard/vault/:product([^/]*)*/:vertical()/completion",
    meta: completionfKdYh75JPvlu1Fj7VL6_451_45nJALeVMv276P1GdMXQQhwMeta || {},
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/vault/[...product]/[vertical]/completion.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-quotes-results",
    path: "/health-insurance/visitors-visa-ovhc/quotes-results",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/quotes-results.vue")
  },
  {
    name: "life-insurance-income-protection-quote-confirmation",
    path: "/life-insurance/income-protection/quote/confirmation",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/life-insurance/income-protection/quote/confirmation.vue")
  },
  {
    name: "dashboard-vault-product-form-energy-step-step",
    path: "/dashboard/vault/:product([^/]*)*/form/energy/step/:step()",
    meta: _91step_93ikdOlZTaCLAIz_EJwsHlIHjfLs91otjvD6d1w7jwPoYMeta || {},
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/vault/[...product]/form/energy/step/[step].vue")
  },
  {
    name: "dashboard-vault-product-form-generic-step-step",
    path: "/dashboard/vault/:product([^/]*)*/form/generic/step/:step()",
    meta: _91step_93U1EhOp3MxCKUcevlcC_45bk8nPrkjm7iGN_45u6IbFzj_45PUMeta || {},
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/vault/[...product]/form/generic/step/[step].vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-application-step",
    path: "/health-insurance/visitors-visa-ovhc/application/:step()",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/application/[step].vue")
  },
  {
    name: "dashboard-vault-product-form-home-loan-step-step",
    path: "/dashboard/vault/:product([^/]*)*/form/home-loan/step/:step()",
    meta: _91step_93JM_7vnlh0VS1kLHjfpfxWgf5IykXuzJIRK5q100nYqEMeta || {},
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/vault/[...product]/form/home-loan/step/[step].vue")
  },
  {
    name: "health-insurance-students-offer-university-form",
    path: "/health-insurance/students-offer/:university()/form",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/students-offer/[university]/form/index.vue")
  },
  {
    name: "dashboard-vault-product-vertical-additional-details",
    path: "/dashboard/vault/:product([^/]*)*/:vertical()/additional-details",
    meta: additional_45detailsAYJMPuMSw2qqlWkW1l4dW5VwrHvaQHM7sqFRJczd_45gsMeta || {},
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/vault/[...product]/[vertical]/additional-details.vue")
  },
  {
    name: "dashboard-vault-product-form-life-insurance-step-step",
    path: "/dashboard/vault/:product([^/]*)*/form/life-insurance/step/:step()",
    meta: _91step_93cvgED8W_kvK40fBra6zZo15eeXAciJdFtq_45EODA3eccMeta || {},
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/vault/[...product]/form/life-insurance/step/[step].vue")
  },
  {
    name: "dashboard-vault-product-form-health-insurance-step-step",
    path: "/dashboard/vault/:product([^/]*)*/form/health-insurance/step/:step()",
    meta: _91step_93tbGQhZQebZFwq7caXzgbVbYGHC_45jzr4oghnm1HSWi3sMeta || {},
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/dashboard/vault/[...product]/form/health-insurance/step/[step].vue")
  },
  {
    name: "health-insurance-students-offer-university-terms-conditions",
    path: "/health-insurance/students-offer/:university()/terms-conditions",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/health-insurance/students-offer/[university]/terms-conditions/index.vue")
  },
  {
    name: "Guides",
    path: "/credit-cards/guides",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/[vertical]/guides.vue")
  },
  {
    name: "Companies",
    path: "/credit-cards/companies",
    component: () => import("/codebuild/output/src701941157/src/packages/nuxt/pages/[vertical]/companies/index.vue")
  }
]